import React, { useState,useEffect,useRef } from 'react'
import FormGroup from 'jd-library/FormGroup';
import FormLabel from 'jd-library/FormLabel';
import Form from 'jd-library/Form'
import FormRadio from 'jd-library/FormRadio'
import './audit-enrich-product.scss'
import {setLoggedUser} from '../../actions/index';
import toastMessageActions from "jd-library/toastMessageActions";
import { Link } from "react-router-dom";
import helmet from 'helmet';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import withRipple from 'jd-library/withRipple'
import Button from 'jd-library/Button'
import {useHistory, useParams, useLocation} from 'react-router-dom';
import {setAuditEnrichData,postAuditEnrichData,skipAuditEnrichData} from '../../actions/auditEnrich';
import {fetchAuditUrl,fetchAuditEnrichProduct,logOut, auditSearch} from '../../utills';
import UpgradeModal from 'jd-library/UpgradeModal'
import Dropdown from 'jd-library/Dropdown'
import InputWithTag from 'jd-library/InputWithTag'
import ActionDialog from 'jd-library/ActionDialog'
import Modal from 'jd-library/Modal'
import './audit-enrich-product.scss';
import querystring from 'querystring';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Image from '../../common/product-image/ImageViewUpload';
import VideoPlayer from '../../../client/common/Video/VideoPlayerWrapper';
import { showToastMessage } from '../../actions/toastmessage';

	const productImageDropDownObj = [
	{
		label: 'Select Reason',
		key: 'select_reason',
	},
	{
		label: 'Incorrect Image',
		key: 'incorrect_image',
	},
	{
		label: 'Blur Image',
		key: 'blur_image',
	},
	{
		label: 'Duplicate Image',
		key: 'duplicate_image',
	},
	{
		label: 'Images with Watermarks',
		key: 'images_with_watermarks',
	},
	]
	const productPackagingImage_LabelDDObj = [

	{
		label: 'Select Reason',
		key: 'select_reason',
	},
	{
		label: 'Incorrect Image',
		key: 'incorrect_image',
	},
	{
		label: 'Blur Image',
		key: 'blur_image',
	},
	{
		label: 'Duplicate Image',
		key: 'duplicate_image',
	},
	{
		label: 'Images with Watermarks',
		key: 'images_with_watermarks',
	},


	]
	const specificationDDObj = [
		{
		label: 'Select Reason',
		key: 'select_reason',
	},
	{
		label: 'Incorrect specification value',
		key: 'incorrect_specification_value',
	},
	{
		label: 'Duplicate Specification',
		key: 'duplicate_specification',
	},
	{
		label: 'Irrelevant Specification',
		key: 'irrelevant_specification',
	},
	]
	const descriptionDDObj = [
			{
		label: 'Select Reason',
		key: 'select_reason',
	},
	{
		label: 'Junk Description',
		key: 'junk_description',
	},
	{
		label: 'Irrelevant changes',
		key: 'irrelevant_changes',
	}
	]
	const productVideoObj = [
	{
		label: 'Select Reason',
		key: 'select_reason',
	},
	{
		label: 'Irrelevant Video',
		key: 'irrelevant_video',
	},
	{
		label: 'Video with competitor Water Mark',
		key: 'video_with_competitor_water_mark',
	}
	]

const auditEnrichModule = () => {
	const [value,setValue] = useState("")
	const [productData ,setProductData] = useState([])
	const [showModal, setModal] = useState(false)
	const [productNameModal,setProductNameModal] = useState(false)
	let [count,setCount] = useState(1234)
	let [userRefLinks,setUserRefLinks] = useState([{}])
	const [valueDD,setValueDD] = useState({contentObj : [],specificatonObj: [],deatilsObj : []})
	const [objForPost,setObjForPost] = useState({contentObj : [],specificatonObj: [],deatilsObj : []})
	const [productImagevalue,setProductImagevalue] = useState([])
	const [productPackagingImagevalue,setProductPackagingImagevalue] = useState([])
	const [descriptionvalue,setDescriptionvalue] = useState([])
	const [specificationvalue,setSpecificationvalue] = useState([])
	const [productVideovalue,setProductVideovalue] = useState([])
	// const [selectedItem, changeItem] = useState([]);
	const selectedItem = useRef(new Array())
	const enrichDataRes = useRef({obj : ""})
	const [rejectDD,setRejectDD] = useState(false)
	const dropDownD = useRef(new Array())
	const [dropDown,setDropDown] = useState([])
	const [tableRow,setTableRow] = useState([])
	const [ddProductImage,setDdProductImage] = ([])
	const [productImageDD, setProductImageDD] = useState([])
	const [productPackageImageDD, setProductPackageImageDD] = useState([])
	const [descriptionDD, setDescriptionDD] = useState([])
	const [specificationDD, setSpecificationDD] = useState([])
	const [productVideoDD, setProductVideoDD] = useState([])
	const [productPackagingImagevalueappendValue,setProductPackagingImagevalueappendValue] = useState([])
	const [productImagevalueappendValue,setProductImagevalueappendValue] = useState([])
	const [descriptionvalueappendValue,setDescriptionvalueappendValue] = useState([])
	const [specificationvalueappendValue,setSpecificationvalueappendValue] = useState([])
	const [productVideovalueappendValue,setProductVideovalueappendValue] = useState([])
	const [veryArrProductPackagingImage,setVeryArrProductPackagingImage] = useState({})
	const [veryArrProductImage,setVeryArrProductImage] = useState({})
	const [veryArrDescription,setVeryArrDescription] = useState({})
	const [veryArrSpecification,setVeryArrSpecification] = useState({})
	const [veryArrProductVideo,setVeryArrProductVideo] = useState({})
	const [test, setTest] = useState('')
	const [veryRadio, setVeryRadio] = useState([]);
	const [prodImageArr,setProdImageArr] = useState([])
	const [contentData,setContentData] = useState( {obj : []});
	const [specificationData,setSpecificationData] = useState({obj : []})
	const [detailsData,setDetailsData] = useState({obj : []});
	const [contentDetailseDd,setContentDetailsDd] = useState({obj : []})
	const [specificationDetailseDd,setSpecificationDetailsDd] = useState({obj : []})
	const [productId,setProductId] = useState(null)//'184553162' , 21643826
	const [detailsDd,setDetailsDd] = useState({obj : []})
	const [, updateState] = React.useState();
 	const forceUpdate = React.useCallback(() => updateState({}), []);
	const [userProductName,setUserProductName] = useState('')
	const [userEditedProductName,setUserEditedProductName] = useState('')
	const [validateContent,setValidateContent] = useState('');
	const [validateSpecification,setValidateSpecification] = useState('');
	const [validateDetails,setValidateDetails] = useState('');
	const radioArr = []

	let productNameRef = useRef('');

	let dispatch = useDispatch();
	let history = useHistory();


	const enrichData = useSelector((state)=> state.auditEnrichInfo.enrichProducts);
	const enrichDataPostResponse = useSelector((state)=> state.auditEnrichInfo.postEnrichProductResponse.results);
	const session = useSelector((state)=> state.session);
	const initProduct = useSelector((state)=> state.auditEnrichInfo.initEnrichProduct)
	console.log('initProductinitProductinitProduct',initProduct);
	enrichDataRes.current.obj = enrichDataPostResponse && enrichDataPostResponse

	var len = (enrichData.length)

	const saveEnrichAudit = async(cb, isRedirect) => {
		console.log('saveEnrichAudit');

       
		let contentObjSoft = objForPost.contentObj.filter(e => e.status == 'Reject' && e.reason == '')
		let specificatonObjSoft = objForPost.specificatonObj.filter(e => e.status == 'Reject' && e.reason == '')
		let deatilsObjSoft = objForPost.deatilsObj.filter(e => e.status == 'Reject' && e.reason == '')
		
		setValidateContent(contentObjSoft.map(e=> e.id))
		setValidateSpecification(specificatonObjSoft.map(e=> e.id))
		setValidateDetails(deatilsObjSoft.map(e=> e.id))
		
		if (contentObjSoft.length == 0 && specificatonObjSoft.length == 0 && deatilsObjSoft == 0){
		selectedItem.current.map(e => {
			if (e.slice(0,-7) == 'productImage' || e.slice(0,-7) == 'productPackagingImage' || e.slice(0,-7) == 'productVideo')
			{
			const objToPush =
			setContentData(objToPush)
			let rea =  String(e.match(/\d/g))
			let da = contentDetailseDd.obj.filter(e=> e.charAt(0) == rea && e)

			contentData.obj.push({'id' : String(e.match(/\d/g)), 'status' : (e && e.slice(-6) == 'Accept' ? '1' : '-1') || '','reason':String(da).substring(1)})
			}
			else if (e.slice(0,-7) == 'specification') {
				let rea =  String(e.match(/\d/g))
				let da = specificationDetailseDd.obj.filter(e=> e.charAt(0) == rea && e)
				specificationData.obj.push({'id' : e.match(/\d/g), 'status' :  e.slice(-6),'reason':String(da).substring(1)})
			}
			else if (e.slice(0,-7) == 'description') {
				let rea =  String(e.match(/\d/g))
				let da = detailsDd.obj.filter(e=> e.charAt(0) == rea && e)
				detailsData.obj.push({'id' : e.match(/\d/g), 'status' : e.slice(-6) || '','reason':String(da).substring(1)})
			}
		})
		function statusReplace(data) {
		let statusReplaced = data && data.map((item) => {
			let dataObj = item;
			if(item.status == "Reject") {
				dataObj.status = -1;
			} else {
				dataObj.status = 1;
			}
			return dataObj;
		})
		return statusReplaced;
		}	
		const objToSend = {
			'contentData' : JSON.stringify(statusReplace(objForPost.contentObj)),
			'specificationData' : JSON.stringify(statusReplace(objForPost.specificatonObj)),
			'detailsData' :  JSON.stringify(statusReplace(objForPost.deatilsObj)),
			'productName' : userProductName ? userProductName : '',
			'auditor' : session?.user?.loggedUser?.userName
		}

		console.log('objToSend',(objToSend));
		const finalObj = {
			id : initProduct.productId,
			data : querystring.stringify(objToSend),
			}
		console.log('finalObj',finalObj);
		dispatch(postAuditEnrichData({finalObj, cb : ()=>{
			if(isRedirect){
				cb && cb(redirectToHome)
			}else{
				cb && cb()
			}
		}}))
		}else if (contentObjSoft.length != 0 || specificatonObjSoft.length != 0 || deatilsObjSoft != 0){
				console.log('b4 tost');
			dispatch(
        	toastMessageActions.showMessage({
          	showToastMessage: true,
          	message: `Please Select The DropDown`,
          	duration: 3000,
          	type: "error",
        	}))
		}




	}
	const setEnrichData = (initProduct)=>{
		let dataObj = {};
		dataObj.token = session.token;
		dataObj.productId = initProduct.productId;
		// dataObj.productId = 178105958;
		dispatch(setAuditEnrichData(dataObj));
	}
	useEffect( () => {
		console.log('useEffect called');
		setEnrichData(initProduct);
		setProdImageArr(enrichData.data?.results?.content?.images)
		setUserRefLinks(enrichData.data?.reference_link)
	}, [])
	useEffect(() => {
	  setProdImageArr(enrichData.data?.results?.content?.images)
		setUserEditedProductName(enrichData?.data?.results?.productName)
		setUserProductName(enrichData?.data?.results?.productName)
		setUserRefLinks(enrichData?.data?.results?.reference_link)
	}, [enrichData])

	const onBtnClick = () => {
	setModal(true)
	console.log('onBtnClick called');
	}
	const productNameChange = () => {
		console.log('productNameChange called');
		setProductNameModal(true)
	}
	const productNameModalClose = () => {
		console.log('productNameChange called');
		setUserEditedProductName(userProductName)
		setProductNameModal(false)
	}
	const onHidden = () => {
	setModal(false)
	}
	const refLinks = () => {}

	const setUserData = (dataOf,id,method,reason) => {
		const a = objForPost.deatilsObj;
		console.log('dataOf',dataOf,`id`,id,`method`,method,`reason`,reason);

			let softContentArr = [...objForPost.contentObj]
			let softDetailsArr = [...objForPost.deatilsObj]
			let softSpecificationArr = [...objForPost.specificatonObj]
			console.log('softContentArr',softContentArr);
			let indCon = softContentArr.findIndex(x => x.id == Number(id))
			let indObjCon = softContentArr[indCon]
			let indDet = objForPost.deatilsObj.findIndex(x => x.id == Number(id))
			let indObjDet = objForPost.deatilsObj[indDet]
			let indSpex = objForPost.specificatonObj.findIndex(x => x.id == Number(id))
			let indObjSpex = objForPost.specificatonObj[indSpex]


			if (dataOf == 'productImage' || dataOf == 'productPackagingImage' || dataOf == 'productVideo') {
				softContentArr[indCon] = {id: Number(id), status: method ? method : indObjCon.status, reason: (method == 'Accept') ? '' :  reason ? reason :  indObjCon.reason}

				setObjForPost({...objForPost, contentObj : softContentArr})
			}else if (dataOf == 'description') {
			 	softDetailsArr[indDet] = {id: Number(id), status: method ? method : indObjDet.status, reason: (method == 'Accept') ? '' : reason ? reason :  indObjDet.reason}
				setObjForPost({...objForPost, deatilsObj : softDetailsArr})
			}else if (dataOf == 'specification') {
				softSpecificationArr[indSpex] = {id: Number(id), status: method ? method : indObjSpex.status, reason: (method == 'Accept') ? '' : reason ? reason :  indObjSpex.reason}
				setObjForPost({...objForPost, specificatonObj : softSpecificationArr})
			}
	}

	const changeSelectedItem = (dataOf,id,method) => {
		let item = `${dataOf}${id}${method}`
		setUserData(dataOf,id,method,'')


		if (dataOf == 'productImage' || dataOf == 'productPackagingImage' || dataOf == 'productVideo'){

			const softContentObj = objForPost.contentObj
			let obj = {id: null,status : 'Accept',reason : ''}

		}else if (dataOf == 'specification'){
			const softSpecificationObj = objForPost.specificatonObj

		}else if (dataOf == 'description'){
			const softDetailsObj = objForPost.deatilsObj

		}

		let indexofItem = selectedItem.current.indexOf(`${dataOf}${id}`);
		let slicedArr1 = []
		let slicedArr2 = []
		slicedArr1 = selectedItem.current && selectedItem.current.map(x => x.replace('Accept', ''))
		slicedArr2 = slicedArr1 && slicedArr1.map(x => x.replace('Reject', ''))
		if (!slicedArr2.includes(`${dataOf}${id}`)){
			selectedItem.current.push(item)
		}else {
			const asdsd =  slicedArr2.indexOf(`${dataOf}${id}`)
			selectedItem.current[asdsd] = item;

		}
		let softTableRow = tableRow
		if (tableRow.indexOf(`${dataOf}`) > -1){
			console.log(`already ${dataOf} present`);
		}else {
			console.log(`already ${dataOf} not present so adding into tableRow`);
			setTableRow([...tableRow, dataOf])
		}
		console.log('after setting table row->',tableRow);

			if (dataOf == 'productImage'){
			let index  = productImageDD.indexOf(id)
			if (method == 'Reject'){
				if (index == -1) {
				setProductImageDD([...productImageDD,id])
			}
			}else if (method == 'Accept') {
				if (productImageDD.includes(id)){
					productImageDD.splice(productImageDD.indexOf(id),1)
				}
			}

		}else if (dataOf == 'productPackagingImage'){
		let index  = productPackageImageDD.indexOf(id)
			if (method == 'Reject'){
				if (index == -1) {
				setProductPackageImageDD([...productPackageImageDD,id])
			}
			}else if (method == 'Accept') {
				if (productPackageImageDD.includes(id)){
					productPackageImageDD.splice(productPackageImageDD.indexOf(id),1)
				}
			}
		}else if (dataOf == 'description'){
				let index  = descriptionDD.indexOf(id)
				if (method == 'Reject'){
				if (index == -1) {
				setDescriptionDD([...descriptionDD,id])
			}
			}else if (method == 'Accept') {
				if (descriptionDD.includes(id)){
					descriptionDD.splice(descriptionDD.indexOf(id),1)
				}
			}
		}else if (dataOf == 'specification'){
			let index  = specificationDD.indexOf(id)
			if (method == 'Reject'){
				if (index == -1) {
				setSpecificationDD([...specificationDD,id])
			}
			}else if (method == 'Accept') {
				if (specificationDD.includes(id)){
					specificationDD.splice(specificationDD.indexOf(id),1)
				}
			}
		}else if (dataOf == 'productVideo'){
		let index  = productVideoDD.indexOf(id)
			if (method == 'Reject'){
				if (index == -1) {
				setProductVideoDD([...productVideoDD,id])
			}
			}else if (method == 'Accept') {
				if (productVideoDD.includes(id)){
					productVideoDD.splice(productVideoDD.indexOf(id),1)
				}
			}
		}
		forceUpdate()
	}
	const onSubmit = () => {
    let item = selectedItem || 'No Option';
    window.alert(item + ' has been selected');
	}
	const inputProps = {
	label: 'Enter Tags',
	onUpdate: (data) => {
		}
	};

		const clipBoardCopy = (id,type) => {
		if (type == 'productId') {
			var valueToCopy = id
			var myTemporaryInputElement = valueToCopy;
			var myTemporaryInputElement = document.createElement("input");
    		myTemporaryInputElement.type = "text";
    		myTemporaryInputElement.value = valueToCopy;
			document.body.appendChild(myTemporaryInputElement);
			myTemporaryInputElement.select();
			document.execCommand("Copy");
			document.body.removeChild(myTemporaryInputElement);
		}else if (type== 'product_bankid'){
			var valueToCopy = id || ''
			var myTemporaryInputElement = valueToCopy;
			var myTemporaryInputElement = document.createElement("input");
    		myTemporaryInputElement.type = "text";
    		myTemporaryInputElement.value = valueToCopy;
			document.body.appendChild(myTemporaryInputElement);
			myTemporaryInputElement.select();
			document.execCommand("Copy");
			document.body.removeChild(myTemporaryInputElement);
		}
		dispatch(
        	toastMessageActions.showMessage({
          	showToastMessage: true,
          	message: `${id} coppied`,
          	duration: 1500,
          	type: "success",
        	}))
	}


	const dropDownSet = (e,value,element,rowName) => {
		console.log('dropDownSet',e,'value',value,'element',element,'rowName',rowName);
		setUserData(rowName,element.id,'',e.key)
		let val = `${element.id}${e.key}`
		if (rowName == 'productPackagingImage') {
			if (!productPackagingImagevalue.includes(`${val}`)){
				setProductPackagingImagevalue([...productPackagingImagevalue,val])
			}

			const newValueDD = {...valueDD}
			let { contentObj:newContentObj } = newValueDD;
			newContentObj = [ ...newContentObj, `${element.id}${e.key}`]
			newValueDD.contentObj = newContentObj
			valueDD.contentObj.push(`${element.id}${e.key}`)
			let ddVal = {id : element.id,key : e.key} //sandeep

			veryArrProductPackagingImage[element.id]= e.key;
			console.log('veryArr',veryArrProductPackagingImage);
			setVeryArrProductPackagingImage({...veryArrProductPackagingImage})
			setProductPackagingImagevalueappendValue([...productPackagingImagevalueappendValue,ddVal])
			productPackagingImagevalueToAppend(element.id)

		}
		else if (rowName == 'productImage') {
				if (!productImagevalue.includes(`${val}`)){
				setProductImagevalue([...productImagevalue,val])
			}
			const newValueDD = {...valueDD}
			let { contentObj:newContentObj } = newValueDD;
			newContentObj = [ ...newContentObj, `${element.id}${e.key}`]
			newValueDD.contentObj = newContentObj
			valueDD.contentObj.push(`${element.id}${e.key}`)
			let ddVal = {id : element.id,key : e.key}


			veryArrProductImage[element.id]= e.key;
			setVeryArrProductImage({...veryArrProductImage})

			setProductImagevalueappendValue([...productImagevalueappendValue,ddVal])

		}else if (rowName == 'description'){
				if (!descriptionvalue.includes(`${val}`)){
				setDescriptionvalue([...descriptionvalue,val])
			}
			const newValueDD = {...valueDD}
			let { contentObj:newContentObj } = newValueDD;
			newContentObj = [ ...newContentObj, `${element.id}${e.key}`]
			newValueDD.contentObj = newContentObj
			valueDD.contentObj.push(`${element.id}${e.key}`)
			let ddVal = {id : element.id,key : e.key}

			// veryArrDescription

			veryArrDescription[element.id]= e.key;
			console.log('veryArr',veryArrDescription);
			setVeryArrDescription({...veryArrDescription})
			setDescriptionvalueappendValue([...descriptionvalueappendValue,ddVal])

		}else if (rowName == 'specification'){
				if (!specificationvalue.includes(`${val}`)){
				setSpecificationvalue([...specificationvalue,val])
			}
			const newValueDD = {...valueDD}
			let { contentObj:newContentObj } = newValueDD;
			newContentObj = [ ...newContentObj, `${element.id}${e.key}`]
			newValueDD.contentObj = newContentObj
			valueDD.contentObj.push(`${element.id}${e.key}`)
			let ddVal = {id : element.id,key : e.key}

			// veryArrProductImage

			veryArrSpecification[element.id]= e.key;
			console.log('veryArr',veryArrSpecification);
			setVeryArrSpecification({...veryArrSpecification})

			setSpecificationvalueappendValue([...specificationvalueappendValue,ddVal])

		}else if (rowName == 'productVideo'){
				if (!productVideovalue.includes(`${val}`)){
				setProductVideovalue([...productVideovalue,val])
			}
			const newValueDD = {...valueDD}
			let { contentObj:newContentObj } = newValueDD;
			newContentObj = [ ...newContentObj, `${element.id}${e.key}`]
			newValueDD.contentObj = newContentObj
			valueDD.contentObj.push(`${element.id}${e.key}`)

			let ddVal = {id : element.id,key : e.key}


			veryArrProductVideo[element.id]= e.key;
			console.log('veryArr',veryArrProductVideo);
			setVeryArrProductVideo({...veryArrProductVideo})

			setProductVideovalueappendValue([...productVideovalueappendValue,ddVal])

		}
		console.log('contentDetailseDd',contentDetailseDd,'specificationDetailseDd',specificationDetailseDd,'detailsDd',detailsDd);

	}
	// const onLinkClick=(element)=>{
	// 	let url = `http://${element}`
	// 	window.open(url, '_blank').focus();
	// }

	const editProductName = (e) => {
		setUserProductName(e.target.value)
	}

	const logOutUser = ()=> {
		logOut({
			token : session.token,
			cb:(data)=> {
				if (data.data.isSuccess){
					dispatch(setLoggedUser(null))
					history.push("/audit-enrich-login");
				}
			}
		})
	}

	const skipAuditEnrich = (cb,isRedirect) => {
		let finalObj = {
			id : initProduct.productId,
		}
		dispatch(skipAuditEnrichData({id : initProduct.productId, cb : () => {
			if (isRedirect) {
				cb && cb(redirectToHome)
			}else {
				cb && cb()
			}
		}}))
	}
	const redirectToHome = (data) => {
		if(data){
			dispatch(
				toastMessageActions.showMessage({
				showToastMessage: true,
				message: `No Data Redirecting To Home`,
				duration: 3000,
				type: "info",
			}))
		}
		console.log('redirectToHome');
		history.push("/audit-enrich-home");
	}

	const skipStopAudit = () => {
		console.log('skipStopAudit');
		skipAuditEnrich(redirectToHome);
		redirectToHome();
	}
	const saveStopAudit = () => {
		console.log('saveStopAudit');
		saveEnrichAudit(redirectToHome)
		// redirectToHome()
	}
	const skipFetechAnother =() => {
		console.log('skipFetechAnother');
		let isRedirect = true;
		skipAuditEnrich(fetchAuditEnrichProduct,isRedirect);
		// history.push("/audit-enrich-home");
	}
	const saveFetchAnother = () => {
		console.log('saveFetchAnother');
		let isRedirect = true
		saveEnrichAudit(fetchAuditEnrichProduct, isRedirect);
		// history.push("/audit-enrich-home");
		// fetchAuditEnrichProduct();
	}
	const productPackagingImagevalueToAppend = (id) => {
		console.log('productPackagingImagevalueToAppend',id);

	}
	console.log('value',valueDD);

	const getReason = (id) =>{
	const filteredArr = productPackagingImagevalue.map(e=>{
    if(e.match(new RegExp(`^${id}[a-zA-Z].`))){
        let res = e.split(`${id}`)[1];
        return res
    }
	})
	const res =  filteredArr.filter(e => !!e)[filteredArr.length - 1]
	return res

	}

	if (enrichData?.data?.results?.data_available != 0){
		productNameRef.current = enrichData && enrichData?.data?.results?.productName
		let softImageData = enrichData?.data?.results?.content?.images && enrichData?.data?.results?.content?.images
		let softLabelImageData = enrichData?.data?.results?.content?.label_images && enrichData?.data?.results?.content?.label_images
		let softVideosData = enrichData?.data?.results?.content?.videos && enrichData?.data?.results?.content?.videos
		let softSpecificationData = enrichData?.data?.results?.specification && enrichData?.data?.results?.specification
		let softDescriptionData = enrichData?.data?.results?.details.description && enrichData?.data?.results?.details.description

		let objImg = softImageData && softImageData.map(element => {
			return {id : element.id,status : 'Accept',reason : ''}
		})
		let objLblImg = softLabelImageData && softLabelImageData.map(element => {
			return {id : element.id,status : 'Accept',reason : ''}
		})
		let objVideo = softVideosData && softVideosData.map(element => {
			return {id : element.id,status : 'Accept',reason : ''}
		})
		let objSpec =  softSpecificationData && softSpecificationData.map(element => {
			return({id : element.id,status : 'Accept',reason : ''})
		})
		let objDesc =  softDescriptionData && softDescriptionData.map(element => {
			return({id : element.id,status : 'Accept',reason : ''})
		})



		let contentNode = objImg &&  objLblImg && objVideo && [...objImg, ...objLblImg,...objVideo]


			if (contentNode) {
				if (objForPost.contentObj.length == 0 ){
					if (contentNode.length > 0) {
					contentNode && setObjForPost({...objForPost,contentObj : contentNode})
					}

				}
				if (objForPost.specificatonObj.length == 0){
					if (objSpec.length > 0) {
					objSpec && setObjForPost({...objForPost,specificatonObj : objSpec})
					}

				}
				if (objForPost.deatilsObj.length == 0){
					if (objDesc.length > 0) {
					objDesc && setObjForPost({...objForPost,deatilsObj : objDesc})
					}

				}

			}
	}

	// console.log('objForPost',objForPost);
	// console.log('userRefLinks->',userRefLinks);
  return (
    <div className='audit-enrich-product'>
		<div className='audit-enrich-container'>
			<div className='font16 color414 audittitle pl-20 pr-20 pt-20'>
				<div>Enrichment Audit Module</div>
				<div>Audit Pending Count : {enrichData && enrichData?.data?.results?.auditPendingCount || ''}</div>
			</div>
			{(enrichData?.data?.results?.data_available != 0) &&
				<div className="maxWrapper p-20">
				<div className="enrichAudit_wpr">
					<div className="enrichAudit_outer p-30">
						<div className="font16 color353" >Product Name: <b className="fw700">{userEditedProductName ? userEditedProductName : userProductName || ''}</b> <a className="icon-editItem" onClick={productNameChange}>EDIT</a></div>
						{enrichData?.data?.results?.productId ? <div className="font16 color353 mt-15">Product ID: <b className="fw700">{enrichData?.data?.results?.productId}</b><span className="color008 font12 ml-30 prodID" onClick={()=> clipBoardCopy(enrichData?.data?.results?.productId,'productId')}>COPY</span></div> : null}
						<div className="font16 color353 mt-15">Product Bank ID: <b className="fw700">{enrichData && enrichData?.data?.results?.product_bankid || ''}</b> <span className="color008 font12 ml-30 prodbankID" onClick={()=> clipBoardCopy(enrichData?.data?.results?.product_bankid,'product_bankid')}>COPY</span></div>
						<div className="product_table_wpr mt-45">
							<div className="product_table_hdr font16 color414 fw600">
								<div className="product_tbl_th"></div>
								<div className="product_tbl_th">Previous Value</div>
								<div className="product_tbl_th">New Value</div>
								<div className="product_tbl_th">Action</div>
							</div>

							{enrichData?.data?.results?.content?.images.length > 0 &&
								enrichData?.data?.results?.content?.images.map((element,index)=> {
									return(
										<>
											<div className="product_table_row font16 color414">
											<div className="product_tbl_td fw600">{index == 0 ? 'Product Image' : ''}</div>
											<div className="product_tbl_td">
												<Image
												className="imgbox"
												imageUrl={element.old_file_path}
												isReadOnly={true}
												/>
											</div>
											<div className={element.new ? `product_tbl_td pinkbg` : "product_tbl_td greenbg"}>
												<Image
													className="imgbox"
													imageUrl={element.new_file_path}
													isReadOnly={true}
												/>
											</div>
											<div className="product_tbl_td">
												<div className={`radio_actions radio_actions_${element.id}`}>
													<span className="action_chkbox">
														<label>
															<div className='radioButton_class' >
																<FormRadio className='check_box' name={`productPackagingImage${element.id}action`} onClick={()=> {changeSelectedItem(`productImage`,`${element.id}`,`Accept`)}} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Accept'}  label='Accept' labelClass='label-row'/>
															</div>

														</label>
													</span>
													<span className="action_chkbox ml-22">
														<label>
															<div>
																<FormRadio className='check_box' name={`productImage${element.id}action`} onClick={()=> {changeSelectedItem(`productImage`,`${element.id}`,`Reject`)}} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Reject'} label='Reject' labelClass='label-row'/>
															</div>
														</label>
													</span>
												<div>
													{
														<div className={tableRow.indexOf('productImage') > -1 && productImageDD && (productImageDD.includes(String(element.id)) ) ? "dropdown_visible" : "dropdown_invisible"}>
															<Dropdown
																className={validateContent.includes((element.id)) ? 'dropdown-div-error' : 'dropdown-div'}
																// className={'dropdown-div'}
																optionList={productImageDropDownObj}
																style={{ maxWidth: '320px' }}
																onChange={(e, value) => {
																	dropDownSet(e,value,element,'productImage');
																}}
																placeholder='Select'
																value={veryArrProductImage[`${element.id}`]}
															></Dropdown>
														</div>
													}
												</div>
											</div>
											</div>
										</div>
										</>
									)
								})
							}


							{enrichData?.data?.results?.content?.label_images.length > 0 &&
								enrichData?.data?.results?.content?.label_images.map((element,index)=> {
								return(
									<>
										<div className="product_table_row font16 color414">
											<div className="product_tbl_td fw600">{index == 0 ? 'Product Packaging Image' : ''}</div>
												<div className="product_tbl_td">
													<Image
														className="imgbox"
														imageUrl={element.old_file_path}
														isReadOnly={true}
													/>
												</div>
												<div className={element.new ? `product_tbl_td pinkbg` : "product_tbl_td greenbg"}>
													<Image
														className="imgbox"
														imageUrl={element.new_file_path}
														isReadOnly={true}
													/>
												</div>
												<div className="product_tbl_td">
													<div className="radio_actions">
														<span className="action_chkbox">
															<label>
																<div className='radioButton_class' >
																	<FormRadio className='check_box' name={`productPackagingImage${element.id}action`} onClick={()=> {changeSelectedItem(`productPackagingImage`,`${element.id}`,`Accept`)}} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Accept'}  label='Accept' labelClass='label-row'/>
																</div>
															</label>
														</span>
														<span className="action_chkbox ml-22">
															<label>
																<div>
																	<FormRadio className='check_box' name={`productPackagingImage${element.id}action`} onClick={()=> {changeSelectedItem(`productPackagingImage`,`${element.id}`,`Reject`)}} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Reject'} label='Reject' labelClass='label-row'/>
																</div>
															</label>
														</span>
														{tableRow.indexOf('productPackagingImage') > -1 && productPackageImageDD && (productPackageImageDD.includes(String(element.id)) )  &&
															<Dropdown
																className={validateContent.includes((element.id)) ? 'dropdown-div-error' : 'dropdown-div'}
																// className={'dropdown-div'}
																optionList={productPackagingImage_LabelDDObj}
																style={{ maxWidth: '320px' }}
																onChange={(e, value) => {
																	dropDownSet(e,value,element,'productPackagingImage');
																}}
																placeholder='Select Period'

																	value={veryArrProductPackagingImage[`${element.id}`]}
															></Dropdown>
														}

									</div>
												</div>
										</div>
									</>
								)})
							}

							{enrichData?.data?.results?.details?.description.length > 0 &&
								enrichData?.data?.results?.details?.description.map((element,index)=> {
								return (
									<>
										<div className="product_table_row font16 color414">
											<div className="product_tbl_td fw600">{index == 0 ? 'Description:' : ''}</div>
												<div className="product_tbl_td">
													{element.old_data}
												</div>
												<div className={"product_tbl_td pinkbg "}>
													{element.new_data}
												</div>
												<div className="product_tbl_td">
													<div className='radio_actions'>
														<span className="action_chkbox">
															<label>
																<div className='radioButton_class' >
																	<FormRadio className='check_box' name={`description${element.id}action`} onClick={()=> {changeSelectedItem(`description`,`${element.id}`,`Accept`)}} checked={objForPost.deatilsObj.filter(e=> e.id == element.id)[0]?.status == 'Accept'}  label='Accept' labelClass='label-row'/>
																</div>
															</label>
														</span>
														<span className="action_chkbox ml-22">
															<label>
																<div>
																	<FormRadio className='check_box' name={`description${element.id}action`} onClick={()=> {changeSelectedItem(`description`,`${element.id}`,`Reject`)}} checked={objForPost.deatilsObj.filter(e=> e.id == element.id)[0]?.status == 'Reject'} label='Reject' labelClass='label-row'/>
																</div>
															</label>
														</span>
														{tableRow.indexOf('description') > -1 && descriptionDD && (descriptionDD.includes(String(element.id)) )  &&
																<Dropdown
																className={validateDetails.includes((element.id)) ? 'dropdown-div-error' : 'dropdown-div'}
																// className={'dropdown-div'}
																optionList={descriptionDDObj}
																style={{ maxWidth: '320px' }}
																onChange={(e, value) => {
																	dropDownSet(e,value,element,'description');
																}}
																placeholder='Select Period'
																value={veryArrDescription[`${element.id}`]}
															></Dropdown>
														}
											</div>
												</div>

										</div>
									</>
							)})
							}

							{enrichData?.data?.results?.specification.length > 0 &&
								<div className="product_table_row font16 color414">
								<div className="product_tbl_td fw600">Specification:</div>
								<div className="product_tbl_td fullwidth p-0">
									<div className="tbl_innerhdr_row fw600">
										<div>Spec Name</div>
										<div>Spec Value</div>
										<div>Spec Name</div>
										<div>Spec Value</div>
										<div>&nbsp;</div>
									</div>
									{enrichData?.data?.results?.specification.map((element,index)=>{
										return<>
											<div className="tbl_inner_row">
												<div className='specs_content'>{element.attributeName}</div>
												<div className='specs_content'>{element.old_spec_display_value}</div>
												<div className='specs_content pinkbg'>{element.attributeName}</div>
												<div className='specs_content pinkbg'>{element.new_spec_display_value}</div>
												<div className='action_btn_wpr'>
													<span className="action_chkbox">
														<label>
															<div className='radioButton_class' >
																	<FormRadio className='check_box' name={`specification${element.id}action`} onClick={()=> {changeSelectedItem(`specification`,`${element.id}`,`Accept`)}} checked={objForPost.specificatonObj.filter(e=> e.id == element.id)[0]?.status == 'Accept'}  label='Accept' labelClass='label-row'/>
															</div>
														</label>
													</span>
													<span className="action_chkbox ml-22">
														<label>
															<div>
																<FormRadio className='check_box' name={`specification${element.id}action`} onClick={()=> {changeSelectedItem(`specification`,`${element.id}`,`Reject`)}} checked={objForPost.specificatonObj.filter(e=> e.id == element.id)[0]?.status == 'Reject'} label='Reject' labelClass='label-row'/>
															</div>
														</label>
													</span>
														{tableRow.indexOf('specification') > -1 && specificationDD && (specificationDD.includes(String(element.id)) )  &&
															<Dropdown
																// className={'dropdown-div'}
																className={validateSpecification.includes((element.id)) ? 'dropdown-div-error' : 'dropdown-div'}
																optionList={specificationDDObj}
																style={{ maxWidth: '320px' }}
																onChange={(e, value) => {
															dropDownSet(e,value,element,'specification');
														}}
																placeholder='Select Period'
																value={veryArrSpecification[`${element.id}`]}
															>
															</Dropdown>
														}
												</div>
											</div>
										</>
										})}
								</div>
							</div>
							}

							{enrichData?.data?.results?.content?.videos.length > 0 &&
								enrichData?.data?.results?.content?.videos.map((element,index)=> {
									return(
										<>
										<div className="product_table_row font16 color414">
											<div className="product_tbl_td fw600">{index==0 ? 'Product Video' : ''}</div>
											<div className="product_tbl_td">
												<div className="mb-20">Link: <span className="color008">{element?.old_file_path}</span></div>
												{ element?.old_file_path ? <VideoPlayer
													source={new RegExp(/youtu\.?be/i).test(element?.old_file_path) ? "YOUTUBE" : "MANUAL"}
													actualPath={element?.old_file_path}
													imgURL={element?.old_file_path}
													thumbnailURL={element?.old_thumbnail}
													playing
													horizontal
													status="UNDER_REVIEW"
													isVideo
													uploaded
													isEnrich={new RegExp(/youtu\.?be/i).test(element?.old_file_path) ? false : true}
												/> : null}
											</div>
											<div className={element.new ? `product_tbl_td pinkbg` : "product_tbl_td greenbg"}>
												<div className="mb-20">Link: <span className="color008">{element?.new_file_path}</span></div>
												{element?.new_file_path ? <VideoPlayer
													source={new RegExp(/youtu\.?be/i).test(element?.new_file_path) ? "YOUTUBE" : "MANUAL"}
													actualPath={element?.new_file_path}
													imgURL={element?.new_file_path}
													thumbnailURL={element?.new_thumbnail}
													playing
													horizontal
													status="UNDER_REVIEW"
													isVideo
													uploaded
													isEnrich={new RegExp(/youtu\.?be/i).test(element?.new_file_path) ? false : true}
												/> : null}
											</div>
											<div className="product_tbl_td">
												<div className="radio_actions">
													<span className="action_chkbox">
														<label>
															<div className='radioButton_class'>
																<FormRadio className='check_box' name={`productVideo${element.id}action`} onClick={()=> changeSelectedItem(`productVideo`,`${element.id}`,`Accept`)} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Accept'} label='Accept' labelClass='label-row'/>
															</div>
														</label>
													</span>
													<span className="action_chkbox ml-22">
														<label>
															<div>
																<FormRadio className='check_box' name={`productVideo${element.id}action`} onClick={()=> changeSelectedItem(`productVideo`,`${element.id}`,`Reject`)} checked={objForPost.contentObj.filter(e=> e.id == element.id)[0]?.status == 'Reject'} label='Reject' labelClass='label-row'/>
															</div>
														</label>
													</span>
													{tableRow.indexOf('productVideo') > -1 &&
														productVideoDD &&
														(productVideoDD.includes(String(element.id)) ) &&
														<Dropdown
															// className={'dropdown-div'}
															className={validateContent.includes((element.id)) ? 'dropdown-div-error' : 'dropdown-div'}
															optionList={productVideoObj}
															style={{ maxWidth: '320px' }}
															onChange={(e, value) => {
																dropDownSet(e,value,element,'productVideo');
															}}
															placeholder='Select Period'
															value={veryArrProductVideo[`${element.id}`]}
														></Dropdown>
													}
												</div>
											</div>
										</div>
										</>
									)
								})
							}
						</div>
						<div className="audit_btn_wpr mt-30">
							<div>
								<Button className="referencelink_btn" onClick={onBtnClick} >Goto Reference Links</Button>
							</div>
							<div>
								<Button onClick={skipStopAudit}>Skip and Stop Auditing</Button>
								<Button className="ml-20" onClick={saveStopAudit}>Save and Stop Auditing</Button>
								<Button className="ml-20" onClick={skipFetechAnother}>Skip And Fetch Another</Button>
								<Button className="ml-20" onClick={saveFetchAnother}>Save And Fetch Another</Button>

							</div>
						</div>

					</div>
				</div>
			</div>
			}
			{(enrichData?.data?.results?.data_available == 0) &&
				<div className='failResponse'>
					{`No Data Found For This Product Bank ID : ${initProduct.productId} `}
					<div className='failResponse_button'>
						<Button className='failResponse_button_fetchAnother' onClick={skipFetechAnother}>Fetch Another</Button>
						<Button className='failResponse_button_home' onClick={()=>redirectToHome()}>Got To Home</Button>
					</div>

				</div>
			}


		</div>
		{showModal && (
			<UpgradeModal
				title={('title', 'Reference Links')}
				onHidden={onHidden}
				subtext= {userRefLinks && userRefLinks.filter(refLink => refLink!='').map((element,index) =>
						<div className='linkModal'>
						<div className='linkModal_key'>Reference Link {index+1}</div>
						<a className='linkModal_value' href={(element.indexOf('http') == -1 ? 'http://' : '')+`${element}`} target="_blank" >{(element.indexOf('http') == -1 ? 'http://' : '')+element}</a>
						{/* <Link className='linkModal_value' onClick={() => onLinkClick(element)}>{element}</Link> */}
						</div>
					)}
			/>
		)}
		{productNameModal && (
			<Modal
                settings={{
                    modalId: 'center-btn',
                    class: 'enrich-action-modal',
                    variant: 'action',
                }}
                onHidden={() => {
					productNameModalClose()
                }}
            >
                <Modal.CloseIcon />
                <Modal.Header>
                    Edit Product Name
                </Modal.Header>
                <Modal.Body className="modal-body">
					<div className='modal-body-input'>
						<InputWithMovingLabel
							ref={productNameRef}
							label={``}
							errorMessage={''}
							input={{
								value: userProductName || '',
								onChange: e => {editProductName(e)},
							}}
							holderClass={'item-cat-input'}
						/>
					</div>
                </Modal.Body>
                <Modal.CenterButton
	                    className="fs-sb enrich-modal-btn"
                    variant={'primary'}
                    onClick={productNameModalClose}
                >
                    {'Save'}
                </Modal.CenterButton>
            </Modal>
		)}
  </div>
  )

}

export default auditEnrichModule